import axios from "axios";
import { baseUrl } from "../../assets/js/api-provider";
import {toast} from "react-toastify";

// import {data} from '../../assets/js/audit';

export const fetchAuditData = (id) => {
    return axios({
      url: `${baseUrl}/${id}`,
      method: "GET",
    })
      .then((res) => {
        const { status } = res.data;
        if (status !== "success") showErrorToast();
        return res;
      })
      .catch((err) => {
        if(err.response && err.response.data && err.response.data.error)
        showErrorToast(err.response.data.error);
      });
};

const showErrorToast = (message = "Unable to fetch the report!") => {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2000,
    hideProgressBar:true
  });
};
